<script lang="ts" setup>
withDefaults(
  defineProps<{
    theme?: 'dark' | 'light' | 'gray' | 'tint';
  }>(),
  {
    theme: 'light',
  },
);
</script>
<template>
  <span
    class="h-[20px] inline-flex items-center rounded-full border px-sm text-footer leading-none font-semibold uppercase"
    :class="[
      theme === 'light' && 'border-white text-white',
      theme === 'dark' && 'border-primary text-primary',
      theme === 'gray' && 'border-muted text-secondary',
      theme === 'tint' && 'border-tint text-tint',
    ]"
  >
    PRO
  </span>
</template>
